import React, { useContext, useMemo } from "react";
import { FabekeDropdown } from "./FabekeDropdown";
import { useTextDomainContext } from "@/app/providers";
import {
  AutocompleteDropdown,
  AutocompleteMultiDropdown,
} from "./AutocompleteDropdown";
import { SimpleDropdown } from "./SimpleDropdown";
import { usePartnersList } from "@/hooks";

interface PartnerDropdownCommonProps {
  componentLabel?: string;
  defaultValue?: string | string[];
  onChange?: (_event: any) => void;
  required?: boolean;
  multiple?: boolean;
  visualStyle?: "autoComplete" | "autoCompleteMulti" | "simple" | "old";
}

/**
 * Partner dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export function PartnerDropdownCommon(props: PartnerDropdownCommonProps) {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { partnerList: options } = usePartnersList();

  const isMulti = props.multiple || props.visualStyle === "autoCompleteMulti";

  //#region useMemo
  const dropdownProps = useMemo(() => {
    const activeOptions =
      options?.filter((item) => item.status === "Active") || [];

    const ddProps: any = {
      // options,
      options: activeOptions,
      componentLabel:
        props.componentLabel ||
        (isMulti ? gettext("Partners") : gettext("Partner")),
      defaultValue: props.defaultValue ?? (isMulti ? [] : ""),
      visualStyle:
        props.visualStyle || (isMulti ? "autoCompleteMulti" : "autoComplete"),
      size: "small",
    };

    if (props.required) {
      ddProps.required = props.required;
    }

    return ddProps;
  }, [
    gettext,
    isMulti,
    options,
    props.componentLabel,
    props.defaultValue,
    props.required,
    props.visualStyle,
  ]);
  //#endregion useMemo

  //#region Handlers
  /**
   * Handles change event of the partner dropdown
   * @param {object} event event object
   * @returns {void}
   */
  const handleChange = (_event: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(_event);
    }
  };
  //#endregion Handlers

  return (
    <>
      {isMulti && (
        <AutocompleteMultiDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {!isMulti &&
        (props.visualStyle === "autoComplete" || !props.visualStyle) && (
          <AutocompleteDropdown onChange={handleChange} {...dropdownProps} />
        )}

      {!isMulti && props.visualStyle === "simple" && (
        <SimpleDropdown onChange={handleChange} {...dropdownProps} />
      )}

      {!isMulti && props.visualStyle === "old" && (
        <FabekeDropdown onChange={handleChange} {...dropdownProps} />
      )}
    </>
  );
}
